module.exports = __webpack_public_path__ + "static/media/information_system.6e57fd75.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/information_system.png
// module id = 504
// module chunks = 0